"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));

var _i18n = _interopRequireDefault(require("../../util/i18n.js"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardPerformanceRow = _interopRequireDefault(require("./StandardPerformanceRow"));

require("./StandardPerformanceTable.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StandardPerformanceTable =
/*#__PURE__*/
function (_Component) {
  _inherits(StandardPerformanceTable, _Component);

  function StandardPerformanceTable(props) {
    var _this;

    _classCallCheck(this, StandardPerformanceTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StandardPerformanceTable).call(this, props));
    _this.state = {
      i18n: _this.props.translationDictionary ? _this.props.translationDictionary : _i18n.default
    };
    return _this;
  }

  _createClass(StandardPerformanceTable, [{
    key: "renderRows",
    // create the rows
    value: function renderRows() {
      var _this2 = this;

      // Filter out Common Stock, and Crypto
      return this.props.data.filter(function (x) {
        return x.type !== 'CS' && x.type !== 'CY' && x.ticker !== '$CASH';
      }).map(function (fund, index) {
        // Remove the word 'WisdomTree' from Fund/Index name if it's only showing WT funds...
        if (_this2.props.wtFundsOnly) {
          fund.name = fund.name.replace(/WisdomTree/g, '');
        }

        var tooltip = _this2.props.tickerTooltip[fund.ticker];
        return _react.default.createElement(_StandardPerformanceRow.default, {
          key: index,
          fund: fund,
          index: index,
          tickerToolip: tooltip,
          showCommonPeriod: _this2.props.showCommonPeriod,
          showSinceInception: _this2.props.showSinceInception,
          isPortfolio: _this2.props.isPortfolio,
          hideCumulativeReturns: _this2.props.hideCumulativeReturns,
          wtFundsOnly: _this2.props.wtFundsOnly
        });
      });
    } // create the header

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var i18n = this.state.i18n;
      var _this$props = this.props,
          data = _this$props.data,
          showCommonPeriod = _this$props.showCommonPeriod,
          showSinceInception = _this$props.showSinceInception,
          commonPeriodStart = _this$props.commonPeriodStart,
          commonPeriodEnd = _this$props.commonPeriodEnd,
          isPortfolio = _this$props.isPortfolio,
          hideCumulativeReturns = _this$props.hideCumulativeReturns,
          wtFundsOnly = _this$props.wtFundsOnly;
      var stdPerformance = Array.isArray(data[0].stdPerformance) ? data[0].stdPerformance[0] : data[0].stdPerformance;
      var asOfDate = new Date(stdPerformance.asOfDate).toLocaleDateString();
      var commonStartDate = commonPeriodStart ? new Date(commonPeriodStart).toLocaleDateString() : new Date(stdPerformance.commonPeriodNAVStart).toLocaleDateString();
      var commonEndDate = commonPeriodEnd ? new Date(commonPeriodEnd).toLocaleDateString() : new Date(stdPerformance.commonPeriodNAVEnd).toLocaleDateString();
      return _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        colSpan: !isPortfolio ? "2" : "1",
        scope: "colgroup",
        className: "textLeft"
      }, i18n.t('as of'), " ", asOfDate), hideCumulativeReturns === false ? _react.default.createElement("th", {
        colSpan: "3",
        scope: "colgroup",
        className: "borderleft borderbottom textCenter sticky"
      }, i18n.t('Cumulative Returns')) : null, _react.default.createElement("th", {
        colSpan: showCommonPeriod ? "6" : "5",
        scope: "colgroup",
        className: "borderleft borderbottom textCenter sticky"
      }, i18n.t('Average Annual Total Returns'))), _react.default.createElement("tr", null, !isPortfolio ? _react.default.createElement("th", {
        scope: "col",
        className: "textLeft ticker sticky"
      }, i18n.t('Ticker')) : null, _react.default.createElement("th", {
        scope: "col",
        className: (0, _classnames.default)('textLeft', 'name', isPortfolio ? 'sticky' : null)
      }, wtFundsOnly ? i18n.t('wisdomtree-fund-benchmark') : i18n.t('name')), hideCumulativeReturns === false ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("th", {
        scope: "col",
        className: "borderleft textCenter percentage"
      }, i18n.t('1-Month')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter percentage"
      }, i18n.t('3-Month')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter percentage"
      }, i18n.t('YTD'))) : null, _react.default.createElement("th", {
        scope: "col",
        className: "borderleft textCenter percentage"
      }, i18n.t('1-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter percentage"
      }, i18n.t('3-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter percentage"
      }, i18n.t('5-Year')), _react.default.createElement("th", {
        scope: "col",
        className: "textCenter percentage"
      }, i18n.t('10-Year')), showSinceInception ? _react.default.createElement("th", {
        scope: "col",
        className: "textCenter date"
      }, i18n.t('Since'), " ", _react.default.createElement("br", null), i18n.t('Inception')) : null, showCommonPeriod ? _react.default.createElement("th", {
        scope: "col",
        className: "textCenter date"
      }, i18n.t('Common Period'), _react.default.createElement("br", null), " ", commonStartDate, " - ", commonEndDate, "  ") : null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          showTitle = _this$props2.showTitle,
          footnote = _this$props2.footnote;
      return _react.default.createElement("div", {
        className: "perf-table-container"
      }, showTitle ? _react.default.createElement("div", {
        className: "heading"
      }, _i18n.default.t('Standardized Performance')) : null, _react.default.createElement("div", {
        className: "table-responsive"
      }, _react.default.createElement("table", {
        className: "table "
      }, this.renderHeader(), _react.default.createElement("tbody", null, this.renderRows()))), footnote ? _react.default.createElement("div", {
        className: "perf-footnote",
        dangerouslySetInnerHTML: {
          __html: footnote
        }
      }) : _react.default.createElement("div", null, _react.default.createElement("br", null)));
    }
  }]);

  return StandardPerformanceTable;
}(_react.Component);

_defineProperty(StandardPerformanceTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: true,
  showCommonPeriod: true,
  isPortfolio: false,
  showSinceInception: true,
  wtFundsOnly: false,
  hideCumulativeReturns: false,
  tickerTooltip: {}
});

StandardPerformanceTable.propTypes = {
  /**
   * Fund data to be used for Performance. Should be array of funds
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Translation dictionary (i18) - needed for tables, but can default to included version
   */
  translationDictionary: _propTypes.default.object,

  /**
  * Show the title or not
  */
  showTitle: _propTypes.default.bool,

  /**
   * Show the common period returns
   */
  showCommonPeriod: _propTypes.default.bool,

  /**
   * Show the since inception returns
   */
  showSinceInception: _propTypes.default.bool,

  /**
   * Get the commone period start
   */
  commonPeriodStart: _propTypes.default.string,

  /**
   * Get the commone period end
   */
  commonPeriodEnd: _propTypes.default.string,

  /**
   * Indicate if the table is portfolio level
   */
  isPortfolio: _propTypes.default.bool,

  /**
   * Footnote text
   */
  footnote: _propTypes.default.string,

  /**
   * Hide the Cumulative performance columns
   */
  hideCumulativeReturns: _propTypes.default.bool,

  /**
   * Indicates if this table just shows WT funds and indexes/benchmarks. IF so, then remove 'WisdomTree' from the fund name,
   * Change 'Common Period' to 'Since Fund Inception', and change relable Name column
   */
  wtFundsOnly: _propTypes.default.bool
};
var _default = StandardPerformanceTable;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/StandardPerformanceTable.js
// module id = 934
// module chunks = 0